var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegiao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.173,
    height: 30.19,
    viewBox: "0 0 30.173 30.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-5.865 -5.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_35",
    "data-name": "Caminho 35",
    d: "M36.038,20.955A15.1,15.1,0,0,1,20.962,36.05c-.184,0-.382,0-.564-.016h-.215a15.1,15.1,0,0,1,0-30.157H20.4c.182-.017.38-.017.562-.017A15.087,15.087,0,0,1,36.038,20.955Z",
    fill: "#2579a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_36",
    "data-name": "Caminho 36",
    d: "M34.7,20.948A15.113,15.113,0,0,1,20.4,36.027h-.215a15.1,15.1,0,0,1,0-30.157H20.4A15.1,15.1,0,0,1,34.7,20.948Z",
    transform: "translate(0 0.006)",
    fill: "#6fa8c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37",
    "data-name": "Caminho 37",
    d: "M31.455,19.649A11.788,11.788,0,0,1,19.663,31.441,4.314,4.314,0,0,1,19,31.408,11.784,11.784,0,0,1,19,7.874a4.314,4.314,0,0,1,.661-.033A11.8,11.8,0,0,1,31.455,19.649Z",
    transform: "translate(1.296 1.289)",
    fill: "#83c2e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38",
    "data-name": "Caminho 38",
    d: "M30.117,19.635A11.764,11.764,0,0,1,19,31.394,11.784,11.784,0,0,1,19,7.86,11.79,11.79,0,0,1,30.117,19.635Z",
    transform: "translate(1.296 1.303)",
    fill: "#c4deed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_39",
    "data-name": "Caminho 39",
    d: "M19.971,10.609a.408.408,0,0,0-.577,0l-.654.654a.408.408,0,1,0,.577.577l.654-.654a.408.408,0,0,0,0-.577Z",
    transform: "translate(8.31 3.016)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_40",
    "data-name": "Caminho 40",
    d: "M11.841,18.739a.408.408,0,0,0-.577,0l-.654.654a.408.408,0,0,0,.577.577l.654-.654A.408.408,0,0,0,11.841,18.739Z",
    transform: "translate(3.014 8.313)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41",
    "data-name": "Caminho 41",
    d: "M19.971,19.393l-.654-.654a.408.408,0,1,0-.577.577l.654.654a.408.408,0,0,0,.577-.577Z",
    transform: "translate(8.31 8.313)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42",
    "data-name": "Caminho 42",
    d: "M11.841,11.263l-.654-.654a.408.408,0,0,0-.577.577l.654.654a.408.408,0,0,0,.577-.577Z",
    transform: "translate(3.014 3.016)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M11.907,14.058a.147.147,0,0,0-.161.1l-.59,2.024-.317-1.3c-.022-.093-.131-.134-.235-.134s-.217.041-.239.134l-.317,1.3-.59-2.024a.147.147,0,0,0-.161-.1c-.138,0-.31.086-.31.194a.16.16,0,0,0,.007.045l.739,2.349c.034.112.176.164.317.164s.284-.052.31-.164l.243-1.008.239,1.008c.026.112.172.164.31.164a.314.314,0,0,0,.317-.164L12.21,14.3a.162.162,0,0,0,.007-.045C12.217,14.144,12.045,14.058,11.907,14.058Z",
    transform: "translate(2.034 5.34)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M21.515,16.361H20.458v-.751h.568a.169.169,0,0,0,.153-.187c0-.1-.056-.194-.153-.194h-.568v-.747h1.057c.1,0,.153-.1.153-.217,0-.1-.049-.209-.153-.209h-1.33c-.108,0-.213.052-.213.153v2.424c0,.1.1.153.213.153h1.33c.1,0,.153-.108.153-.209C21.668,16.462,21.612,16.361,21.515,16.361Z",
    transform: "translate(9.191 5.34)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    d: "M16.021,8.728c-.123,0-.243.045-.243.149v1.5l-.721-1.393c-.116-.22-.187-.258-.362-.258-.123,0-.243.049-.243.153v2.424c0,.1.12.153.243.153s.243-.052.243-.153V9.8l.8,1.5a.292.292,0,0,0,.28.153c.12,0,.243-.052.243-.153V8.877C16.264,8.773,16.14,8.728,16.021,8.728Z",
    transform: "translate(5.595 1.869)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    d: "M15.017,20.077c0-.179.153-.288.422-.288.314,0,.4.142.515.142.134,0,.194-.172.194-.258,0-.247-.489-.3-.71-.3-.429,0-.908.19-.908.747,0,.885,1.2.713,1.2,1.274,0,.224-.194.325-.418.325-.381,0-.482-.288-.635-.288-.116,0-.213.157-.213.261,0,.217.374.463.863.463a.789.789,0,0,0,.889-.81C16.216,20.379,15.017,20.54,15.017,20.077Z",
    transform: "translate(5.603 8.805)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    d: "M23.014,22.449l-3.663-5.757a2.157,2.157,0,0,0-1.473-1.473l-5.757-3.663a.408.408,0,0,0-.563.563l3.663,5.757a2.157,2.157,0,0,0,1.473,1.473l5.757,3.663a.408.408,0,0,0,.563-.563Zm-7.147-6.777-.024.021q-.078.071-.149.149l-.021.024-.048.055-.025.032L15.561,16l-.026.036-.035.05-.025.039-.031.05-.024.042-.028.05-.022.044-.025.051-.021.045-.023.052-.005.012L13.231,13.23l3.244,2.064-.012.005-.052.023-.045.02-.051.026-.043.022-.051.029-.041.024-.05.032-.039.025-.05.035L16,15.56l-.051.04-.032.025Zm1.342,2.943-.021,0-.056-.005-.023,0-.054-.008-.023,0-.057-.012a1.337,1.337,0,0,1-.985-.985l-.013-.058,0-.022-.008-.054,0-.023-.005-.056,0-.021c0-.026,0-.051,0-.077a1.334,1.334,0,0,1,1.333-1.333l.077,0,.021,0,.056.005.024,0,.053.008.023,0,.056.012a1.337,1.337,0,0,1,.987.986l.012.057,0,.023.008.054,0,.023.005.056,0,.021c0,.026,0,.051,0,.077a1.334,1.334,0,0,1-1.333,1.333Zm.887.66.012-.005.052-.023.045-.02.051-.026.043-.022.051-.029.041-.024.05-.032.038-.025.051-.036.035-.025.052-.041.031-.024.058-.05.022-.019q.078-.071.149-.149l.019-.022.05-.058.024-.031.041-.052.025-.035.036-.051.025-.038.032-.05.024-.041.029-.051.022-.043.026-.051.02-.045.023-.052.005-.012,2.064,3.244Z",
    transform: "translate(3.667 3.669)",
    fill: "#282828"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegiao);
export default __webpack_public_path__ + "static/media/regiao.4b43e6b3b4aee6e98640246cc3d03335.svg";
export { ForwardRef as ReactComponent };